module.exports = __webpack_public_path__ + "static/media/roulette.ef708b24.gif";